import { Login,Logout } from "@a/login.js";
import Cookies from "js-cookie"
//cookies
import { setToken, setUsername, getUsername, getToken, removeToken, removeUsername } from "../../utils/cookies";
const state ={
    token: "" || getToken(),
    username: "" || getUsername(),
}
const getters ={}
const mutations ={
    SET_TOKEN(state, value){ // 设置 token
        state.token = value;
        value && setToken(value);
    },
    SET_USERNAME(state, value){ // 设置用户名
        state.username = value;
        value && setUsername(value);
    },
}
const actions ={
    loginAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            Login(repuestData).then((response) => {
                let data = response.data[0];
                context.commit('SET_TOKEN', data.uuidtoken);
                context.commit('SET_USERNAME', data.username);
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    logoutAction(context) {
        return new Promise((resolve, reject) => {
            Logout().then((response) => {
                removeToken();
                removeUsername();
                context.commit('SET_TOKEN', "");
                context.commit('SET_USERNAME',"");
                Cookies.remove("userToken")
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};